export const disableScroll = () => {
    if (typeof document !== "undefined") {
        const body = document.querySelector('body');
        if (body && body.classList) {
            body.classList.add('disable-scroll');
        }
    }
};

export const enableScroll = () => {
    if (typeof document !== "undefined") {
        const body = document.querySelector('body');
        if (body && body.classList) {
            body.classList.remove('disable-scroll');
        }
    }
};

export const scrollToError = () => {
    const timeForScroll = 500;

    setTimeout(() => {
        try {
            $("body,html").animate(
                {
                    scrollTop: $('form').find('.has-error').last().offset().top
                },
                timeForScroll
            );
            return;
        } catch (e) {

        }

        try {
            $("body,html").animate(
                {
                    scrollTop: $('form').find('.error-component').first().offset().top - 100
                },
                timeForScroll
            );
        } catch (e) {

        }
    }, 100)
}
